__turbopack_context__.v({
  "--center-empty-submission": "photo-scroll-gallery-module-scss-module__JQv7Hq__--center-empty-submission",
  "--modal-open": "photo-scroll-gallery-module-scss-module__JQv7Hq__--modal-open",
  "__container": "photo-scroll-gallery-module-scss-module__JQv7Hq____container",
  "__stage": "photo-scroll-gallery-module-scss-module__JQv7Hq____stage",
  "__stage-row": "photo-scroll-gallery-module-scss-module__JQv7Hq____stage-row",
  "photo-scroll-gallery": "photo-scroll-gallery-module-scss-module__JQv7Hq__photo-scroll-gallery",
});
